"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.truncateLabel = truncateLabel;
function truncateLabel(label, labelLengthOverflow) {
  return label.substring(0, labelLengthOverflow - 3) + '...';
}